import * as React from 'react';
import { CSSObject } from '@emotion/react';
import { FixMeLater } from '../../utils';
import { DividerProps } from '../Divider/Divider';
import { AutocompleterOptionProps } from './AutocompleterOption';
import { useHoneycombTheme } from '../../theming';

export type AutocompleterListProps = {
    /**
     * The child `AutocompleterOption` components.
     */
    children?: React.ReactElement<AutocompleterOptionProps | DividerProps>[];

    labelledById?: string;

    subList?: boolean;
};

export const AutocompleterList: React.ForwardRefExoticComponent<
    AutocompleterListProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function AutocompleterList(
    props: AutocompleterListProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, labelledById, subList, ...other } = props;

    const { theme } = useHoneycombTheme();
    const dividerColor = theme.palette.grey.lightest;

    const styles: CSSObject = {
        borderTop: subList ? `solid 1px ${dividerColor}` : undefined,
        '> * + *': {
            borderTop: `solid 1px ${dividerColor}`,
        },
    };

    return (
        <ul ref={ref} css={styles} role="listbox" aria-labelledby={labelledById} {...other}>
            {children}
        </ul>
    );
});
